import firebase from "@firebase/app";
import "@firebase/auth";

const config = {
    apiKey: "AIzaSyDYBu3D5R38izbiLioTfOz00KxVTbPeqFE",
    authDomain: "pronaid-beta.firebaseapp.com",
    databaseURL: "https://pronaid-beta.firebaseio.com",
    projectId: "pronaid-beta",
    storageBucket: "",
    messagingSenderId: "622194731063",
    appId: "1:622194731063:web:e4e2bfa56cd8205a"
};
/* eslint-disable no-new */

firebase.initializeApp(config)